
import { RouteReuseStrategy, ActivatedRouteSnapshot, DetachedRouteHandle } from '@angular/router';
import { Injectable } from "@angular/core";

@Injectable()
export class RouteReuseService implements RouteReuseStrategy {
    private handlers: { [key: string]: DetachedRouteHandle } = {};
    shouldDetach(route: ActivatedRouteSnapshot): boolean {//console.log("In shouldDetach")
        const routeConfig = route.routeConfig;
        if (!routeConfig || routeConfig.loadChildren) {
            return false;
        }
        let shouldReuse = false;
        //console.log('checking if this route should be re used or not', route);
        if (routeConfig.data) {
            routeConfig.data.reuse ? shouldReuse = true : shouldReuse = false;
        }
        return shouldReuse;
    }

    store(route: ActivatedRouteSnapshot, handler: DetachedRouteHandle): void {//console.log("In store")
        //console.log('storing handler');
        if (handler) {
            this.handlers[this.getUrl(route)] = handler;
        }
    }

    shouldAttach(route: ActivatedRouteSnapshot): boolean {//console.log("In shouldAttach")
        //console.log('checking if it should be re attached');
        let reloadURL = false;
        const routeConfig = route.routeConfig;
        const routePath = routeConfig?.path;
        if (routePath) {
            switch (routePath){
                case "ind-home":
                    //console.log("shouldReuse case toString IND-home: "+routePath);
                    sessionStorage.getItem("onreference_reuse_ind-home") ? reloadURL = false : reloadURL = true;
                    break;
                case "org-home":
                    //console.log("shouldReuse case toString ORG-home"+routePath);
                    sessionStorage.getItem("onreference_reuse_org-home") ? reloadURL = false : reloadURL = true;
                    break;
                default:
            }    
        }
        if (reloadURL){//console.l  og("return false on reloadURL");
            return false;
        }
        return !!this.handlers[this.getUrl(route)];
    }

    retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {//console.log("In retrieve")
        if (!route.routeConfig || route.routeConfig.loadChildren) {
            return null;
        };
        return this.handlers[this.getUrl(route)] ?? null;
    }

    shouldReuseRoute(future: ActivatedRouteSnapshot, current: ActivatedRouteSnapshot): boolean {//console.log("In Should Use route");
        let reUseUrl = false;
        if (future.routeConfig) {
            if (future.routeConfig.data) {
                reUseUrl = future.routeConfig.data.reuse;
            }
        }

        const defaultReuse = (future.routeConfig === current.routeConfig);

        return reUseUrl || defaultReuse;
    }

    getUrl(route: ActivatedRouteSnapshot): string {//console.log("In getUrl")
        const url = route.routeConfig?.path ?? '';
        //console.log('returning url', url);
        return url;
    }
}
